import { application } from './application'

import ChartjsController from './chartjs_controller'
import ClipboardController from './clipboard_controller'
import ConfirmModalController from './confirm_modal_controller'
import DisplayOnSelectController from './display_on_select_controller'
import DropdownController from './dropdown_controller'
import FileInputFeedbackController from './file_input_feedback_controller'
import FlatpickrController from './flatpickr_controller'
import FormController from './form_controller'
import IbanChannelController from './iban_channel_controller'
import KycFileBackSelectionMenuController from './kyc_file_back_selection_menu_controller'
import LemonwayIframeController from './lemonway_iframe_controller'
import ModalController from './modal_controller'
import PopoverController from './popover_controller'
import QualificationStepController from './qualification_step_controller'
import RadioButtonVisibilityController from './radio_button_visibility_controller'
import RisksStepController from './risks_step_controller'
import ToggleFieldController from './toggle_field_controller'
import TomSelectController from './tom_select_controller'

application.register('chartjs', ChartjsController)
application.register('clipboard', ClipboardController)
application.register('confirm-modal', ConfirmModalController)
application.register('display-on-select', DisplayOnSelectController)
application.register('dropdown', DropdownController)
application.register('file-input-feedback', FileInputFeedbackController)
application.register('flatpickr', FlatpickrController)
application.register('form', FormController)
application.register('iban-channel', IbanChannelController)
application.register('kyc-file-back-selection-menu', KycFileBackSelectionMenuController)
application.register('lemonway-iframe', LemonwayIframeController)
application.register('modal', ModalController)
application.register('popover', PopoverController)
application.register('qualification-step', QualificationStepController)
application.register('radio-button-visibility', RadioButtonVisibilityController)
application.register('risks-step', RisksStepController)
application.register('toggle-field', ToggleFieldController);
application.register('tom-select', TomSelectController)
